import { IconGrid } from "../Icons/IconGrid";
import { IconList } from "../Icons/IconList";

export const ViewToggle = ({ viewType, setViewType }) => {
  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <div
        onClick={() => setViewType("tile")}
        style={{
          cursor: "pointer",
          padding: "4px",
          borderRadius: "6px",
          backgroundColor: viewType === "tile" ? "#f0f0f0" : "transparent",
        }}
        title="Tile View"
      >
        <IconGrid isActive={viewType === "tile"} />
      </div>

      <div
        onClick={() => setViewType("list")}
        style={{
          cursor: "pointer",
          padding: "4px",
          borderRadius: "6px",
          backgroundColor: viewType === "list" ? "#f0f0f0" : "transparent",
        }}
        title="List View"
      >
        <IconList isActive={viewType === "list"} />
      </div>
    </div>
  );
};
